<template>
  <div >
    <div>
      <a-modal
        title="选择角色"
        :dialogStyle="dialogStyle"
        :width="width"
        :visible="visible"
        switchFullscreen
        @ok="handleOk"
        :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
        @cancel="handleCancel"
        cancelText="关闭"
      >
        <div class="data">
          <div class="search">
            <div >
              <span > {{ this.configData.queryLabel }}: </span>
              <span> <a-input v-model="model.queryKey" :placeholder="'请输入'+this.configData.queryLabel "   allowClear></a-input>

              </span>
              <span><a-button  type="primary"  icon="search" @click="querySubmit">查询</a-button></span>
              <span><a-button type="primary"  icon="reload" @click="searchReset()">重置</a-button></span>
            </div>
            <div ><span>已选{{selectDisplayName}}</span></div>

          </div>
          <div class="data_table">
            <div >
              <a-table
                ref="table"
                size="middle"
                :scroll="{x:500}"
                bordered
                :rowKey="this.configData.primaryKey"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                class="j-table-force-nowrap"
                :rowSelection="{selectedRowKeys: selectedKeys, onChange: onSelectChange1,type: multiple ? 'checkbox':'radio'}"
                @change="handleTableChange"></a-table>

            </div>
            <div>
              <div >
                <a-table
                  ref="table"
                  size="middle"
                  bordered
                  :rowKey="this.configData.primaryKey"
                  :columns="columnsSelected"
                  :dataSource="dataSourceSelected"
                  :loading="loading"
                  :pagination="false"
                  class="j-table-force-nowrap"
                  :scroll="{ y: 300 }"
                  >
                    <span slot="action" slot-scope="text, record">
                        <a  @click="deleteSelected(record)">删除</a>
                      </span>


                </a-table>


              </div>

            </div>
          </div>

        </div>

      </a-modal>
    </div>
  </div>
</template>
<script>
import { getAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  mixins:[JeecgListMixin, mixinDevice],
  props:{
    modelVisible:{
      type: Boolean,
      default: false,
    },
    multiple:{
      type: Boolean,
      default: true,
    },
    configData:{
      type: Object,
      default: {},
    },
    fatcherSelectedItems:{
      type: Array,
      default: null
    }
  },
  data() {
    return {
      description: 'portal头部',
      width:900,
      closable:false,
      disableSubmit: false,
      isLogin:false,
      selectDisplayName:"",
      queryKey:this.configData.queryKey,
      model:{},
      primaryKey:this.configData.primaryKey,
      dialogStyle: {
        top: "100px",
        height:"500px",
        width:"1900px"

      },
      visible:false,
      url: {
        list: this.configData.url

      },
      dataSourceSelected:[],
      selectedKeys:[],
     // selectedRows:[],
      selectedRowKeysSelected:[],
      selectedItems:this.fatcherSelectedItems,
      firstSelectedKeys:[],//缓存select选择的值。防止用户点击关闭按钮会把弹出框选中的值同步到父组件
      firstDataSourceSelected:[],//缓存select选择的值。防止用户点击关闭按钮会把弹出框选中的值同步到父组件

    };
  },created() {
    this.ipagination.pageSize=5;
    //初次需加载数据库已保存的数据已做显示
    this.loadSelectItemData();
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    columns() {
      if (this.language) {
        return this.configData.colunmList;
      }
    },
    columnsSelected() {
      if (this.language) {

        let selectDataObj;
        for (const columObj of this.configData.colunmList) {
             if(columObj.dataIndex==this.configData.displayKey){
               selectDataObj=columObj;
               this.selectDisplayName=columObj.title;
               break;
             }
        }

        return [
          { title: selectDataObj.title, dataIndex: selectDataObj.dataIndex, align: 'center', width: 50,ellipsis:true },
          {
            title:"操作",
            width: 50,
            align:"center",
            scopedSlots: { customRender: 'action' }

          }
        ]
      }
    },

  },
  methods: {
    querySubmit(){
      // console.log("model:",this.model)

      this.queryParam[this.configData.queryKey]=this.model.queryKey;
      this.loadData(1);
    },
    loadSelectItemData(){
      //初始化选中的select值（只会加载一次，在created中调用）
      this.selectedKeys=[];
      let param={
        pageNo: 1,
        pageSize: this.selectedItems.length
      }
      param[`${this.configData.primaryKey}s`]=this.selectedItems.join(','),
      getAction(this.configData.url, param).then((res) => {
        if (res.success) {
          for (const item of res.result.records) {
              this.selectedKeys.push(item[this.configData.primaryKey]);
              this.dataSourceSelected.push(item);
          }
          //console.log("this.selectedKeys:",this.selectedKeys)
          this.firstSelectedKeys=Object.assign([], this.selectedKeys);
          this.firstDataSourceSelected=  Object.assign([],this.dataSourceSelected);
          this.$emit("selectSubmit",this.dataSourceSelected);
        }
      })


    },
    close () {
      this.$emit('close');
      // this.visible = false;
    },
    handleOk () {
      //console.log("selectedKeys:",this.dataSourceSelected);
      //同步父组件select的值
      this.firstSelectedKeys=Object.assign([], this.selectedKeys);
      this.firstDataSourceSelected=  Object.assign([],this.dataSourceSelected);
      this.$emit("selectSubmit",this.dataSourceSelected);
      this.handleCancel();
    }, handleCancel() {
      //alert('handleCancel');
      this.close ();
      this.visible=false;
      //console.log("fist",this.firstSelectedKeys,this.firstDataSourceSelected)
    },onSelectChange1(selectedRowKeys, selectionRows) {
      //左边列表中checxbox（radio）选择或者取消调用的方法
      /*console.log("===selectedRowKeys====", selectedRowKeys)
      console.log("===selectionRows====",selectionRows)*/
      this.selectedKeys = selectedRowKeys;
      // this.selectedRows = selectionRows;
       //添加已选元素（如果元素已存在就不添加。避免重复添加）
      for (const selectItem of selectionRows) {
        let isExist=false;
        for (const dataItem of this.dataSourceSelected) {
          if(selectItem[this.primaryKey]==dataItem[this.primaryKey]){
            isExist=true;
            break;
          }
        }
        if(!isExist){
          this.dataSourceSelected.push(selectItem);
        }
      }
      // this.dataSourceSelected=selectionRows;



      //移除已经取消的元素
     let that=this;
      this.dataSourceSelected.forEach(function(obj,index,array){
          let isExist=false;
        // console.log(that.primaryKey)
            for (const selectedKey of selectedRowKeys) {
               if(selectedKey==obj[that.primaryKey]){
                 isExist=true;
                 break;
               }
          }
        if(!isExist){
          array.splice(index,1);
        }
      });
      //console.log("===this.dataSourceSelected====", this.dataSourceSelected)
    },
    deleteSelected(val){
      //删除已选数据
      console.log(val)
      //移除已经取消的元素
      let that=this;
      this.dataSourceSelected.forEach(function(obj,index,array){
        if(val[that.primaryKey]==obj[that.primaryKey]){
          array.splice(index,1);
        }
      });
     // this.selectedKeys=[];
      this.selectedKeys.forEach(function(obj,index,array){
        if(val[that.primaryKey]==obj){
          that.selectedKeys.splice(index,1);
        }
      });
      // this.selectedRows.forEach(function(obj,index,array){
      //   if(val[that.primaryKey]==obj[that.primaryKey]){
      //     array.splice(index,1);
      //   }
      // });
    },
    modelShow(visible){
      this.visible=visible;
    }
  },watch:{
    firstDataSourceSelected: {
      immediate: true,
      deep: true,
      handler(val) {
        //console.log("this.firstDataSourceSelected,",val)
      },
    },
    visible: {
      immediate: true,
      deep: true,
      handler(val) {
         if(val){
           //每次打开弹出框同步父组件select的值
           this.selectedKeys= Object.assign([], this.firstSelectedKeys);
           this.dataSourceSelected=Object.assign([], this.firstDataSourceSelected);
         }
      },
    },
    selectedRowKeys: {
      immediate: true,
      deep: true,
      handler(val) {
        //console.log("=======selectedRowKeys watch=======",val)
      },
    },
    fatcherSelectedItems: {
      immediate: true,
      deep: true,
      handler(val) {
         console.log("=======selectedItems watch=======",val,this.dataSourceSelected)
        //父组件select框点叉叉删除掉元素。也需要更新子组件里面的选中值
        this.selectedKeys=val;
        let newArray=[];
        this.firstSelectedKeys=[];
        this.firstDataSourceSelected=[];
        for (const oldItem of this.dataSourceSelected) {
          for (const key of this.selectedKeys) {
               if(oldItem[this.primaryKey]==key){
                 newArray.push(oldItem);
                 this.firstSelectedKeys.push(key);
                 this.firstDataSourceSelected.push(oldItem);
                 break;
               }
          }
        }
        // console.log("=======selectedItems newArray=======",newArray)
        this.dataSourceSelected=newArray;
      },
    }
  }
};
</script>
<style>
.data{
  margin: 0;
  width: 100%;
  height: 500px;
/*  border: red solid 1px;*/
}

.data>div:first-child{
  margin: 0;
  width: 100%;
  height: 10%;
  /*border: #0800ff solid 1px;*/
  display: flex;

}

.data>div:first-child>div:first-child{
  margin: 0;
  width: 65%;
  height: 100%;
  /*border: #ff0026 solid 1px;*/
  display: flex;
  align-items:center;
/*  justify-content:space-evenly;*/
}
.data>div:first-child>div:first-child>span{
  /*border: #8400ff solid 1px;*/
  margin-right: 20px;
}
.data>div:first-child>div:first-child>span:first-child{
  font-weight:540;
  color: #000c17;
}
.data>div:first-child>div:nth-child(2){
  width: 30%;
  height: 100%;
/*  border: #00ff48 solid 1px;*/
  margin-left: auto;
  align-items: flex-end;
  display: flex;
}


.data>div:nth-child(2){
  margin: 0;
  width: 100%;
  height: 80%;
  /*border: #b90e64 solid 1px;*/
  display: flex;
}
.data>div:nth-child(2)>div:first-child{
  margin: 0;
  width: 65%;
  height: 100%;
  /*border: #b90e64 solid 1px;*/
}
.data>div:nth-child(2)>div:nth-child(2){
  width: 30%;
  height: 100%;
  /*border: #0e72b9 solid 1px;*/
  margin-right: 0;
  margin-left: auto;

}
</style>